export const ERROR_TEXT = {
  required: 'Обязательное поле',
}
